import React from "react";
import Hero from "../components/Hero";
import Collection from "../components/Collection";
import WhyLoveIt from "../components/WhyLoveIt";
import InTheWild from "../components/InTheWild";
import CtaBanner from "../components/CtaBanner";

const Home = () => {
  return (
    <main className="hm-home-page">
      <Hero />
      <Collection />
      <WhyLoveIt />
      <InTheWild />
      <CtaBanner />
    </main>
  );
};

export default Home;
